<template>
  <div class="tl-margin-layout">
    <svg width="100%" height="100%" id="leftOffsetBracket" ref="leftOffsetBracket" v-show="false">
      <rect
        x="0"
        y="0"
        width="100%"
        height="55"
        opacity=".45"
        fill="#f7f7f7"
      ></rect>
      <line
        :x1 = "10"
        :x2 = "20"
        :y1 = "60"
        :y2 = "60"
        :style = "sliderColor"
      />
      <line
        :x1 = "10"
        :x2 = "20"
        :y1 = "105"
        :y2 = "105"
        :style = "sliderColor"
      />
      <line
        :x1 = "20"
        :x2 = "20"
        :y1 = "60"
        :y2 = "105"
        :style = "sliderColor"
      />
      <line
        :x1 = "20"
        :x2 = "width"
        :y1 = "82"
        :y2 = "82"
        :style = "sliderColor"
      />
    </svg>
  </div>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import NumericField from '@/components/nelson/NumericField';

export default {
  components: {
    NumericField
  },
  mounted () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  unmounted () {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    pipeLeftOffset: {
      get () {
        return useInputStore().getPipeLeftOffset;
      },
      set (value) {
        useInputStore().setPipeLeftOffset(parseInt(value));
      }
    },
    sliderColor () {
      return 'stroke:rgb(' + useSegmentStore().hexToRgb('#000000')  + ')';
    },
    sprinklerSpacing: {
      get () {
        return useInputStore().getSprinklerSpacing;
      },
      set (value) {
        useInputStore().setSprinklerSpacing(parseInt(value));
      }
    },
    width () {
      return useInputStore().getLeftOffsetBracketWidth;
    },
  },
  methods: {
    handleResize () {
      useInputStore().setLeftOffsetBracketWidth(this.$refs.leftOffsetBracket.clientWidth);
    },
  }
};
</script>

<style scoped>
.tl-margin-layout {
  display: flex;
  flex-direction: row;
  height: 110px;
  width: 100%;
}
.spacer {
  height: 5%;
}
.margin-label {
  height: 20%;
  user-select: none;
}
.chart-input {
  border-radius: 15px;
  height: 20%;
  text-align: center;
  user-select: none;
  width: 100%;
  border: none;
}
.chart-input-box {
  display: flex; 
  flex-direction: row; 
  align-items: center; 
  justify-content: space-between;
}
.upper-numeric {
  background-color: rgba(247, 247, 247, 0.45);
  width: 100%;
}
</style>